import React, { useEffect, useRef, useState } from "react";

interface AutocompleteProps {
  adressType?: "geocode" | "address" | "establishment";
  country?: string; // 2-letter ISO code, e.g., "FR"
  value?: string;
  onSelect: (place: google.maps.places.PlaceResult) => void;
}

const AutocompleteComponent: React.FC<AutocompleteProps> = ({
  adressType = "address",
  country = "FR",
  value = "",
  onSelect,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const [inputValue, setInputValue] = useState(value);

  // Sync external value
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  // Initialize Google Autocomplete
  useEffect(() => {
    if (!window.google || !inputRef.current) return;

    autocompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: [adressType], // 'address' ensures postal code
        fields: ["address_components", "formatted_address"],
        componentRestrictions: { country: country.toUpperCase() }, // must be 2-letter uppercase
      }
    );

    autocompleteRef.current.addListener("place_changed", () => {
      const place = autocompleteRef.current?.getPlace();
      
      if (!place) return;
      // Extract postal code
      if (place.address_components) {
        const postal = place.address_components.find((c: any) =>
          c.types.includes("postal_code")
        );
        if (postal) setInputValue(postal.short_name);
        else if (place.formatted_address) setInputValue(place.formatted_address);
      }

      onSelect(place);
    });

    return () => {
      if (autocompleteRef.current) {
        google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [adressType, country, onSelect]);

  return (
    <input
      ref={inputRef}
      type="text"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder="Enter address"
      name="x_xx1" autoComplete="new-password"
     className="input-field w-100"
    />
  );
};

export default AutocompleteComponent;
